import Home from "containers/home/home.component";
import Header from "components/header/header.component";
import React, { Fragment, useEffect, useState, WheelEvent } from "react";
import "shell/shell.component.scss";
import Loader from "components/loader/loader.component";
import ShellContext from "./shell.context";
import { PHASES } from "const/phases.const";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import NftTerms from "containers/nftTerms/nftTerms.component";
import Footer from "components/footer/footer.component";

export function Shell() {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [loaderLoaded, setLoaderLoaded] = useState<boolean>(false);
  const [pageLoaded, setPageLoaded] = useState<boolean>(false);

  const handlePageLoaded = () => setPageLoaded(true);

  useEffect(() => {
    if (pageLoaded) {
      setLoaded(true);
    }
  }, [pageLoaded]);

  useEffect(() => {
    const root = document.getElementById('root');
    if (!!root) {
      if (!loaded) {
        root.style.position = 'fixed';
        root.style.left = '0';
        root.style.top = '0';
        root.style.width = '100%';
        root.style.height = '100vh';
      } else {
       root.setAttribute('style', '')
      }
    }
    
  }, [loaded]);

  return (
    <ShellContext.Provider
      value={{
        phaseOn: true,
        phase: PHASES.AIRDROP,
        loaded: loaded,
      }}
    >
      {!!loaderLoaded && (
        <>
          <Header />
          <Routes>
            <Route path="/" element={<Home onLoaded={handlePageLoaded} />} />
            <Route
              path="/terms"
              element={<NftTerms onLoaded={handlePageLoaded} />}
            />
          </Routes>
          <Footer />
        </>
      )}
      <Loader visible={!loaded} onLoaded={() => setLoaderLoaded(true)} />
    </ShellContext.Provider>
  );
}
